define( function() {
	return ( /\S+/g );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/rnotwhite.js
// module id = 839
// module chunks = 2